export class DriverOOJCredential {
    public id: number;
    public credentialNumber: string;
    public travelId: boolean;
    public compliant: boolean;
    public stateId: number;
    public countryId: number;
    public issueDate;
    public expirationDate;
    public licenseClassTypeIds: number[];
    public endorsementTypeIds: number[];
    public restrictionTypeIds: number[];
    public source: string;
    public active: boolean;
}
